import styled from "styled-components";
import { Tabs } from "@cinesys/ui/components";

/**
 * The manager's page-level nav (rendered immediately below \`Header\`, before any route content)
 * reads as a continuation of the header bar itself — same background, no dividing border.
 */
const PageTabs = styled(Tabs)`
  background: var(--dark090);
  border-bottom: none;
  padding: 0 15px;
`;

export default PageTabs;
